module.exports = __webpack_public_path__ + "static/media/peapay.86ec7c68.png";